import axios from 'axios'
import { ApiData } from './api-data-factory'

class CommonApiService {
  /**
   * Getter method to call the Client side code
   */
  execute(rawRequest = {}, CONFIG, params = {}) {
    const url =
      (ApiData.ENVIRONMENT_URL || '') + (CONFIG.url || CONFIG.endpoint)

    return new Promise((resolve, reject) => {
      axios({
        method: CONFIG.method === 'GET' ? 'get' : 'post',
        url,
        data: rawRequest,
        params,
        timeout: CONFIG.timeout
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const commonApiService = new CommonApiService()

export { commonApiService as CommonApiService }
